import { render, staticRenderFns } from "./GaleriaImagemProductComponent.vue?vue&type=template&id=048684f5&scoped=true"
import script from "./GaleriaImagemProductComponent.vue?vue&type=script&lang=js"
export * from "./GaleriaImagemProductComponent.vue?vue&type=script&lang=js"
import style0 from "./GaleriaImagemProductComponent.vue?vue&type=style&index=0&id=048684f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048684f5",
  null
  
)

export default component.exports